import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Division Name',
    field: 'divisionName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    searchable: true,
  },
];
